import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsInstance, IsObject, IsOptional, IsString, Length, ValidateNested } from 'class-validator';
import { OrderConfigExposeGroup } from '../../order-config/interface';
import { prepTimeCalculationContext } from '../../order-config/swagger';
import { PatchPrepTimeCalculationContextDto } from './PatchPrepTimeCalculationContextDto';
export class PatchPrepTimeCalculationDailyScheduleDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Hours interval with extended config', example: '08:00/10:00' }),
    Length(1, 50),
    IsString({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchPrepTimeCalculationDailyScheduleDto.prototype, "interval", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => PatchPrepTimeCalculationContextDto,
        description: 'Preparation context for specific interval',
        example: prepTimeCalculationContext,
    }),
    Type(() => PatchPrepTimeCalculationContextDto),
    ValidateNested({ always: true }),
    IsInstance(PatchPrepTimeCalculationContextDto, { always: true }),
    IsObject({ always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", PatchPrepTimeCalculationContextDto)
], PatchPrepTimeCalculationDailyScheduleDto.prototype, "context", void 0);
//# sourceMappingURL=PatchPrepTimeCalculationDailyScheduleDto.js.map